import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { PodcastEpisodeModel, PodcastTabModel } from '../models';
import PodcastEpisodeScreen from '../screens/Podcast/PodcastEpisodeScreen';
import PodcastFeedScreen from '../screens/Podcast/PodcastFeedScreen';
import PodcastHomeScreen from '../screens/Podcast/PodcastHomeScreen';

export type PodcastStackNavigatorParams = {
  PodcastHome: {
    options: PodcastTabModel;
  };
  PodcastFeed: {
    podcastUrl: string;
    tabName?: string;
    podcastId?: string;
  };
  PodcastEpisode: {
    episode: PodcastEpisodeModel;
    tabName?: string;
    podcastId?: string;
    episodeId?: string;
  };
};

const Stack = createNativeStackNavigator<PodcastStackNavigatorParams>();

interface PodcastStackNavigatorProps {
  route: {
    params: {
      options: PodcastTabModel;
    };
  };
}

export default function PodcastStackNavigator({ route }: PodcastStackNavigatorProps) {
  const { options } = route.params;

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="PodcastHome"
        component={PodcastHomeScreen}
        initialParams={{ options }}
      />
      <Stack.Screen name="PodcastFeed" component={PodcastFeedScreen} />
      <Stack.Screen name="PodcastEpisode" component={PodcastEpisodeScreen} />
    </Stack.Navigator>
  );
}
